module.exports = "/_next/static/images/icon-favorite-star-active-60981bc10edaa2ed2baf83ea3049cfc8.svg";